import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TextInputComponent } from './text-input.component';
import { ReactiveFormsModule } from '@angular/forms';
import { IconModule } from '../icon/icon.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { UtilitiesModule } from '../utilities/utilities.module';



@NgModule({
  declarations: [TextInputComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    IconModule,
    BrowserAnimationsModule,
    UtilitiesModule
  ],
  exports: [TextInputComponent]
})
export class TextInputModule { }
